import { z } from "zod";

export type Prompt = {
  id: string;
  key: string;
  content: string;
  isActive: boolean;
  versionNumber: number;
  createdAt: Date;
  updatedAt: Date;
  createdById: string;
  updatedById: string;
};

export type CreatePromptInput = {
  key: string;
  content: string;
};

export type UpdatePromptInput = {
  content?: string;
};

export const promptSchema = z.object({
  id: z.string().uuid(),
  key: z.string(),
  content: z.string(),
  isActive: z.boolean(),
  versionNumber: z.number().int().positive(),
  createdAt: z.date(),
  updatedAt: z.date(),
  createdById: z.string().uuid(),
  updatedById: z.string().uuid(),
}) satisfies z.ZodType<Prompt>;

export const createPromptInputSchema = z.object({
  key: z.string(),
  content: z.string(),
}) satisfies z.ZodType<CreatePromptInput>;

export const updatePromptInputSchema = z.object({
  content: z.string().optional(),
}) satisfies z.ZodType<UpdatePromptInput>;
